<!--
 * @Description: 
 * @Version: 
 * @Autor: houchuanfang
 * @Date: 2022-06-15 14:19:51
 * @LastEditTime: 2022-06-15 14:23:52
-->
<template>
  <div class="heritage_warpper">
    <div class="heritage">
      <header>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }"
          >当前位置：首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>就业孵化基地展示</el-breadcrumb-item>
        </el-breadcrumb>
      </header>
      <section>
        <img src="@/static/center/banners.png" alt="" />
      </section>
      <section>
        <ul class="heritage_list flext">
          <li v-for="(item,index) in list" :key="index" @click="$linkRouter('henan/contentDetail/detail',{id:item.id,name:'孵化'})">
            <img :src="item.logo" alt="" :title="item.name"/>
            <div class="contents marL15">
              <h3>{{item.name}}</h3>
              <p class="p1 line_clamp1">地址：{{item.addrProvince+item.addrCity+item.addrThreeCity+item.addrDetail}}</p>
              <p class="p1">面积：{{item.area}}</p>
            </div>
          </li>
        </ul>
      </section>
    </div>
    <div class="pages">
      <el-pagination
          background
          class="work_pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.pageNum"
          :page-size="page.pageSize"
          layout="prev, pager, next, total, jumper"
          :total="page.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      list:[],
      page: {
        pageNum: 1,
        pageSize: 12,
        total: 0
      },
    }
  },
  methods:{
    async info(){
      let res = await this.$axios.post('/api/app-jycy-henan/henan/incubation/list',this.page);
      if (res.data.success){
        this.list = res.data.data.records;
        this.page.total = res.data.data.total;
      }
    },
    //分页
    handleCurrentChange: function (val) {
      this.page.pageNum = val;
      this.info();
      window.scrollTo(0, 0);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
  },
  created(){
    this.info();
  },
};
</script>

<style lang="less" scoped>
@import "~assets/css/henan/heritage";
</style>
